import React from 'react';
import PropTypes from 'prop-types';

const ContentWrapper = ({ className, style, children }) => (
  <div className={`content ${className}`} style={style}>
    {children}
  </div>
);

ContentWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
};

ContentWrapper.defaultProps = {
  className: '',
  style: {},
};

export default ContentWrapper;
